import React,{useMemo, useState, useEffect} from 'react';
import './Header.css';
import Logo from './logo.png';
import bars from '../assets/bars.png';

export default function Header() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (!isMobile) setOpenMenu(false);
  }, [isMobile]);

  const navItems = useMemo(
    () => ['Home', 'Programs', 'Why us', 'Plans', 'Testimonials'],
    []
  );

  return (
    <header className="header">
      <img src={Logo} alt="logo" className="logo" />

      {isMobile ? (
        <>
          <button
            className="menu-toggle"
            aria-label="Toggle navigation"
            onClick={() => setOpenMenu((v) => !v)}
          >
            <img src={bars} alt="menu" />
          </button>
          {openMenu && (
            <ul className="headerList mobile">
              {navItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </>
      ) : (
        <ul className="headerList">
          {navItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </header>
  );
}
